export const getRandomId = (prefix = 'id'): string => {
    const random = Math.random().toString(36).substring(2, 10);
    return `${prefix}-${random}`;
};
